import CustomTypography from './CustomTypography';

export default CustomTypography;
